import React, { useEffect, useState } from 'react'

import { PlusCircle as PlusCircleIcon } from 'react-feather'
import { useHistory } from 'react-router-dom'
import { Button } from '@material-ui/core'
import { isEmpty } from 'lodash'

import {
  Container,
  ContentHeader,
  FilterButton,
  Filters,
  LoadingFeedback,
  Page,
  Permitted,
} from 'components'

import ChangesManagementTable from './components/ChangesManagementTable'

import { routes } from 'Routes'
import * as service from 'service'
import constants from 'constants/index'

import useFilter from 'hooks/useFilter'

const ChangesManagementMain = () => {
  const history = useHistory()
  const filter = useFilter()

  const [users, setUsers] = useState([])
  const [isUsersLoading, setIsUsersLoading] = useState(false)

  useEffect(() => {
    const loadUsers = async () => {
      setIsUsersLoading(true)
      try {
        const response = await service.dponet.users.get({
          minimal: true,
          perPage: 9999,
        })
        setUsers(response?.data?.users || [])
      } finally {
        setIsUsersLoading(false)
      }
    }

    if (filter.drawerOpen && isEmpty(users)) {
      loadUsers()
    }
    //eslint-disable-next-line
  }, [filter.drawerOpen])

  const {
    PENDING_STATUS_LABEL,
    IN_PROGRESS_STATUS_LABEL,
    OVERDUE_STATUS_LABEL,
    FINALIZED_STATUS_LABEL,
  } = constants.changesManagement

  const redirectToCreate = () => history.push(routes.changesManagement.new)

  return (
    <Page title="Todas as gestões de mudanças">
      <LoadingFeedback open={isUsersLoading} />
      <Container maxWidth={false}>
        <ContentHeader title="Gestão de Mudanças">
          <Permitted tag={constants.permissions.CHANGES_MANAGEMENT.MANAGE}>
            <Button
              variant="contained"
              color="primary"
              startIcon={<PlusCircleIcon size={20} />}
              onClick={redirectToCreate}
              fullWidth
            >
              Criar
            </Button>
          </Permitted>
          <FilterButton setDrawerOpen={filter.setDrawerOpen} fullWidth />
        </ContentHeader>
        <ChangesManagementTable filter={filter} />
      </Container>

      <Filters filter={filter}>
        <input textfieldinput="true" label="Identificador" name="id" />
        <input textfieldinput="true" label="Nome" name="name" />
        <select
          autocompleteselectinput="true"
          label="Responsável"
          name="responsibleId"
          optionvalues={users}
          loading={isUsersLoading}
        />
        <select textfieldinput="true" name="status">
          <option value="">Todos</option>
          <option value={PENDING_STATUS_LABEL}>Pendente</option>
          <option value={IN_PROGRESS_STATUS_LABEL}>Em Andamento</option>
          <option value={OVERDUE_STATUS_LABEL}>Atrasado</option>
          <option value={FINALIZED_STATUS_LABEL}>Finalizado</option>
        </select>
        <input
          datepickerinput="true"
          label="Data de Criação"
          name="createdAt"
        />
        <input datepickerinput="true" label="Prazo" name="deadline" />
      </Filters>
    </Page>
  )
}

export default ChangesManagementMain
